export class FiltrosRepCobranzas{
   
    Usuario : string ='';
    Estado: string = '';
   idEmpresa: string = '4';
    Tipo: string = 'facturas_vencidas';
 
 }